/*!
 * Copyright (c) REWE Digital GmbH
 */
import { Host, h } from "@stencil/core";
/**
 * Back Button component.
 */
export class VxBackButton {
    constructor() {
        /**
         * Goes back in browser history.
         */
        this.goBackInBrowser = () => {
            window.history.back();
        };
        this.disabled = false;
        this.snippets = {
            buttonLabel: 'Zurück',
        };
    }
    /**
     * Render the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render() {
        return (h(Host, { key: '33eca3bdac9b595e6571930f334ca6ab017f1c3d', role: "presentation" }, h("button", { key: '3c3669804eb193ae24cb7f5cc57b2d52b74a5a14', title: this.snippets.buttonLabel, "aria-label": this.snippets.buttonLabel, class: "back-button", disabled: this.disabled, onClick: !this.disabled && this.goBackInBrowser }, h("vx-icon", { key: 'd7fc44e1cbf112cdc5f177b12b03b23c3ae7a2c4', icon: "chevron_left" }))));
    }
    static get is() { return "vx-back-button"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["vx-back-button.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["vx-back-button.css"]
        };
    }
    static get properties() {
        return {
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Whether the button is disabled or not."
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "snippets": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "{ buttonLabel: string; }",
                    "resolved": "{ buttonLabel: string; }",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "defaultValue": "{\n        buttonLabel: 'Zur\u00FCck',\n    }"
            }
        };
    }
}
//# sourceMappingURL=vx-back-button.js.map
